import { useState } from 'react'
import { Icon } from '@iconify/react'
import { useParams } from 'react-router-dom'
import { useModal } from '@ebay/nice-modal-react'
import { useMessage } from '@pepper/ui'

import EmptyStateCard from 'components/EmptyStateCard'
import CreateContentPopover from 'components/CreateContentPopover'
import { createPrivateDocument } from 'utils/api/item'
import { useSelectedCompanyId } from 'utils/functions/misc'

import ImportKeywords from 'assets/images/content-ideas/import-keywords.png'
import AiPrompt from 'assets/images/content-ideas/ai-content.png'

import s from './EmptyState.module.css'

export const EmptyState = () => {
  const { show: showProjectSelector } = useModal('select-project-modal')
  const companyId = useSelectedCompanyId()
  const { showError } = useMessage()
  const [showCreateContentPopover, setShowCreateContentPopover] =
    useState(false)
  const { projectId } = useParams<{ projectId: string }>()

  const gotoDoc = (itemId: string, isAIDoc: boolean) => {
    let url = `/${companyId}/items/${itemId}`
    if (isAIDoc) {
      url += '?widget=PEPPER_AI'
    }
    window.open(url, '_blank')
  }

  const handleCreateDoc = async (_projectId: string, isAIDoc = false) => {
    const { data, status, error } = await createPrivateDocument({
      projectId: _projectId,
    })
    if (status === 'ok' && data) {
      gotoDoc(data.item_id, isAIDoc)
    } else {
      showError(error)
    }
  }

  const handleCreateDocClick = async (isAIDoc = false) => {
    if (projectId) {
      handleCreateDoc(projectId, isAIDoc)
    } else {
      showProjectSelector({
        onAfterSelectId: async (_projectId: string) => {
          handleCreateDoc(_projectId, isAIDoc)
        },
      })
    }
  }

  return (
    <div className={s.wrapper}>
      <h4 className={s.title}>Your items appear here..</h4>
      <p className={s.subtitle}>
        Every great content journey begins with a single word. Let’s get
        started! 👇
      </p>
      <div className={s.cardsWrapper}>
        <EmptyStateCard
          alt="pepper doc"
          image={AiPrompt}
          title="Create item using AI prompt"
          description="Begin the document by directing the AI to commence drafting the content."
          icon={<Icon width={22} icon="lucide:users" />}
          onClick={() => handleCreateDocClick(false)}
        />

        <EmptyStateCard
          alt="order from experts"
          image={ImportKeywords}
          title="Start from empty Doc"
          description="From a clean slate to a masterpiece: write with or without AI – it's your playground."
          icon={<Icon width={22} icon="lucide:users" />}
          onClick={() => handleCreateDocClick(true)}
        />
      </div>
      <CreateContentPopover
        showCreateContentPopover={showCreateContentPopover}
        setShowCreateContentPopover={setShowCreateContentPopover}
      />
    </div>
  )
}
